import './GrandNavbar.css'
import grandLogo from '../../../assets/grand/grand-logo-white.png'
import grandLogoDark from '../../../assets/grand/gran-d-logo-transparent.png'
import { useHeaderContext } from '../../../context/Header/HeaderContext'
import { Burger, Button } from '@mantine/core'
import { Link } from 'react-router-dom'
import { useAppContext } from '../../../context/AppState/AppContext'

export default function GrandNavbar({ dark = false }) {
    const { isMobile } = useAppContext()

    const { isMegaMenu, isScrolling, toggleBurger, setToggleBurger } = useHeaderContext()

    const onClickAnchor = () => {
        setToggleBurger(false)
    }


    return (
        <header className={isMegaMenu || isScrolling || toggleBurger ? 'navbar navbar-grand-main active' : 'navbar'}>
            <nav className={`nav-container nav-container--grand ${dark ? "nav-container--grand--dark" : ""}`}>
                <Link to='/grand' className='logo-container' >
                    <img className='logo-grand--image' src={dark ? grandLogoDark : grandLogo} alt="GranD" />
                </Link>

                <ul className={`navbar-navlinks-container ${toggleBurger ? 'navbar-toggle-active' : 'navbar-toggle-inactive'}`}>

                    <a onClick={onClickAnchor} className='navLink' href='/grand#grandes-cursos'>Oferta academica</a>
                    <a onClick={onClickAnchor} className='navLink' href='/grand#alianza'>Alianza</a>
                    <Link className='navLink' to='/'>Ir a Forvet</Link>
                    <Button className='GrandNavbar--campus-btn' component={Link} to='/campus' fw='normal' color='var(--color-grand-accent)' style={{ display: !isMobile ? 'none' : '' }}>
                        CAMPUS
                    </Button>

                </ul>

                <Button className='GrandNavbar--campus-btn' component={Link} to='/campus' fw='normal' color='var(--color-grand-accent)' style={{ display: isMobile ? 'none' : '' }}>
                    CAMPUS
                </Button>

                <Burger
                    color='var(--color-grand-secondary)'
                    className='burger-btn'
                    opened={toggleBurger}
                    onClick={() => {
                        setToggleBurger(!toggleBurger)
                    }}
                    aria-label="Toggle navigation"
                />
            </nav>
        </header>
    )
}